/* 🤖 this file was generated by script */
export const wsolidiconMoon01 = {
  name: 'moon_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M9.07 2.41A1 1 0 0 0 7.74 1.1a11.46 11.46 0 1 0 15.17 15.17 1 1 0 0 0-1.32-1.33q-1.8.82-3.9.84A9.46 9.46 0 0 1 9.07 2.4"/></svg>`,
  iconStyle: 'solid',
};
